import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { onUnauthorized, qk } from './lib/api'
import { buildRouter } from './router'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
})

const router = buildRouter(queryClient)

onUnauthorized(() => {
  queryClient.setQueryData(qk.me, null)
  const { pathname, href } = router.state.location
  if (pathname !== '/login') void router.navigate({ to: '/login', search: { redirect: href } })
})

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
